  // scroll js

  function scrollList(classNames) {
    document.querySelectorAll(classNames).forEach((slider) => {
        let isDown = false, startX, scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const x = e.pageX - slider.offsetLeft;
        slider.scrollLeft = scrollLeft - (x - startX) * 2;
    });
});
}

scrollList(".footer-section .image-with-text-block");
scrollList("header  .header-sub-menu-box.header__inline-menu");


if (window.innerWidth >= 990) {
    // document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    //     document.querySelectorAll('details.mega-menu').forEach(menuDetails => {
    //         const summary = menuDetails.querySelector('summary');
    //         summary.addEventListener('mouseenter', () => {
    //         if (!menuDetails.hasAttribute('open')) {
    //             menuDetails.setAttribute('open', 'true');
    //             summary.setAttribute('aria-expanded', 'true');
    //             document.querySelector('body').classList.add('overflow-hidden');
    //         }
    //         });
    //         menuDetails.addEventListener('mouseleave', () => {
    //             menuDetails.removeAttribute('open');
    //             summary.setAttribute('aria-expanded', 'false');
    //             document.querySelector('body').classList.remove('overflow-hidden');
    //         });
    //         menuDetails.querySelector('.block__menu-overlay').addEventListener('mouseenter', () => {
    //             menuDetails.removeAttribute('open');
    //             summary.setAttribute('aria-expanded', 'false');
    //             document.querySelector('body').classList.remove('overflow-hidden');
    //         });
    //     });
    // });
    document.querySelectorAll('.mega-menu__link--level-2').forEach(menuDetails => {
        menuDetails.addEventListener('mouseenter', () => {
            const sub_menu_title = menuDetails.getAttribute("data-submenu-title1");
            menuDetails.closest('.mega-menu__list').querySelectorAll('.mega-menu__link--level-2').forEach(link => link.classList.remove('sub-active'));
            if (!menuDetails.classList.contains('sub-active')) {
                menuDetails.classList.add('sub-active');
            }
            menuDetails.closest('.mega-menu').querySelectorAll('.block_menu-with-content').forEach(grand_active => {
                grand_active.classList.remove('grandchild-active');
                if (grand_active.dataset.submenuTitle2 === sub_menu_title) {
                    grand_active.classList.add('grandchild-active');
                }
            });
        });
    });
    document.querySelectorAll('.grand-child-link--nav-3').forEach(menuDetails2 => {
        menuDetails2.addEventListener('mouseenter', () => {
            const grandchild_title = menuDetails2.getAttribute("data-grandchild-title1");
            menuDetails2.closest('.block_menu-with-content').querySelectorAll('.grand-child-link--nav-3').forEach(link => link.classList.remove('grandchild-link-active'));
            if (!menuDetails2.classList.contains('grandchild-link-active')) {
                menuDetails2.classList.add('grandchild-link-active');
            }
            menuDetails2.closest('.block_menu-with-content').querySelectorAll('.block__grandchild--menu-content--inner').forEach(grand_active2 => {
                grand_active2.classList.remove('grandchild-content-active');
                if (grand_active2.getAttribute('data-grandchild-title2') === grandchild_title) {
                    grand_active2.classList.add('grandchild-content-active');
                }
            });
        });
    });


} else {
    document.querySelectorAll('.grand-child-link--nav-3').forEach(menuDetails2 => {
        menuDetails2.addEventListener('click', (e) => {
            var __this = e.currentTarget;
            const isActive = __this.classList.contains('active-grand-child-content');
            document.querySelectorAll('.grand-child-link--nav-3').forEach(a_link =>
                a_link.classList.remove('active-grand-child-content')
            );
            document.querySelectorAll('.block__grandchild--menu-content--inner').forEach(link =>
                link.classList.remove('grandchild-content-active')
            );
            if (!isActive) {
                __this.classList.add('active-grand-child-content');
                if(__this.closest('li').querySelector('.block__grandchild--menu-content--inner')){
                    __this.closest('li').querySelector('.block__grandchild--menu-content--inner').classList.add('grandchild-content-active');
                }
            }
        });
    });
}
if (window.innerWidth <= 990) {
    if(document.querySelector('.account-tabs-list ul')){
      const tabsList = document.querySelector('.account-tabs-list ul');
      const tabItems = tabsList.querySelectorAll('li');
  
      tabsList.addEventListener('click', (event) => {
        tabsList.classList.add('active')
        tabItems.forEach((tab) => tab.classList.add('active'));
      });
    }
}

document.querySelectorAll('.block_customers-order-tabbing').forEach(order_tabs => {
    order_tabs.addEventListener('click', (e) => {
        e.preventDefault();
        var __this = e.currentTarget;
        const isActive = __this.closest('.block_customers-order-info').classList.contains('open');
        document.querySelectorAll('.block_customers-order-info').forEach(main_order =>
            main_order.classList.remove('open')
        );
        if (!isActive) {
            __this.closest('.block_customers-order-info').classList.add('open');
        }
    });
});
document.querySelectorAll('.block__product-tabbing-heading').forEach(product_tab => {
    product_tab.addEventListener('click', (e) => {
        e.preventDefault();
        var __this = e.currentTarget;
        const tab_opened = __this.closest('.block__product-tabbing').classList.contains('active');
        document.querySelectorAll('.block__product-tabbing').forEach(main_tab =>
            main_tab.classList.remove('active')
        );
        if (!tab_opened) {
            __this.closest('.block__product-tabbing').classList.add('active');
        }
    });
});

document.querySelectorAll('.block__video-features-popup-btn').forEach(video_popup => {
    video_popup.addEventListener('click', (e) => {
        e.preventDefault();
        var video_url = e.currentTarget.getAttribute('data-url');
        document.querySelector('.block__video-source-popup--main').classList.add('open');
        document.querySelector('.block__video-source-popup--video-frame iframe').setAttribute('src',video_url);
    });
});
document.querySelectorAll('.block__video-source-popup--wrapper .block__popup-close-icon').forEach(video_popup_close => {
    video_popup_close.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.block__video-source-popup--main').classList.remove('open');
        document.querySelector('.block__video-source-popup--video-frame iframe').setAttribute('src','');
    });
});

window.onclick = function(event) {
    var shippignInfoDropdown = document.querySelectorAll(".third_party_provider ul");
    shippignInfoDropdown.forEach(function(opendropdown) {
        if (!opendropdown.classList.contains('hidden')) {
          opendropdown.classList.add('hidden');
        }
    });
  }


document.addEventListener('DOMContentLoaded', function () {
    const placeholderImage = 'https://cdn.shopify.com/s/files/1/0718/2735/7954/files/linkerror.jpg?v=1763526822';
    if(document.querySelectorAll('.card__media .media img').length > 0) {
        document.querySelectorAll('.card__media .media img').forEach(img => {
            img.onerror = function () {
                this.onerror = null;
                this.src = placeholderImage;
                this.srcset = placeholderImage;
            };
        });
    }
    if(document.querySelectorAll('.product__media img').length > 0) {
        document.querySelectorAll('.product__media img').forEach(img => {
            img.onerror = function () {
                this.onerror = null;
                this.src = placeholderImage;
                this.srcset = placeholderImage;
            };
        });
    }
});